import * as React from 'react';
import { emailValidationRegex } from '../../../lib/utils';
import Input, { InputProps } from './Input';

const Email = (props: InputProps) => {
	// eslint-disable-next-line react/jsx-props-no-spreading
	return <Input {...props} type="email" pattern={emailValidationRegex.source} patternMessage="Email is invalid." />;
};

export default Email;
